module.exports = __webpack_public_path__ + "static/img/3.79c0496c.png";